// 轨道类型枚举
const EnumKFTTDouble = 1 // double类型
const EnumKFTTReal3 = 3 // 三维向量(double3)类型
const EnumKFTTQuaternion = 5 // 四元数(quat<double>)类型

// 轨道属性链接类型枚举
const EnumAPBTTranslation = 1 // 位置属性绑定
const EnumAPBTRotation = 2 // 旋转属性绑定
const EnumAPBTScaling = 3 // 缩放属性绑定
// 节点的类型集合
const EnumObjectTypes = [
  'modelFile', // 模型类型
  'dynamicEffects',
]
const actionList = []
// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
const isJSONObj = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj && Object.keys(obj).length) {
        // typeof null 也为 object
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }
  return false
}

// 加载模型
const loadPrModel = async (file, name, parentNode, player) => {
  const nodes = await player.Native.Node.loadFile(file)
  await player.Native.Node.addToFactory(nodes)
  await player.Native.Node.setProperty(nodes, { name, parent: parentNode })
  return nodes[0]
}
// 加载粒子节点
const loadParticle = async (file, name, parentNode, player) => {
  const particleNode = await player.Native.ParticleEffekseer.create(file)
  await player.Native.Node.setProperty(particleNode, { name, parent: parentNode })
  return particleNode
}

const loadSceneFromJson = async (
  obj,
  parentNode,
  player,
  sceneOptions = {
    isEnableGis: false,
    latitude: 0,
    longitude: 0,
  },
  nodes = [],
  loadCallback = () => { }
) => {
  // const fileType = obj.code.fileType
  let node = null
  // 根据节点类型，序列化某些特有类型的节点数据
  switch (obj.code.type) {
    case 'modelFile':
      node = await loadModel(obj.code.filePath, obj.code.id, parentNode, player)
      break
    case 'dynamicEffects':
      node = await loadParticle(obj.code.filePath, obj.name, parentNode, player)
      break
    case 'engineering':
      node = await loadEngineer(obj.code, parentNode, player)
      break
    default:
      // 层级节点，直接根据名称创建节点
      node = await player.Native.NodeProxy.createNode(parentNode, obj.name)
      break
  }
  nodes.push({ type: obj.code.type, nodePtr: node })
  loadCallback(nodes)
  // 节点创建失败，返回nullptr
  if (node !== null && node !== 0) {
    if (obj.code.type === 'Root' && !sceneOptions.isEnableGis) {
      obj.code.isEnableGis = false
      await player.Native.NodeProxy.setLocalTranslation(node, [0, 0, 0])
    } else if (
      obj.code.type === 'Root' &&
      sceneOptions.isEnableGis &&
      sceneOptions.longitude &&
      sceneOptions.latitude
    ) {
      const elevation = (
        await player.Native.GisPlatform.queryDEM([
          [sceneOptions.longitude, sceneOptions.latitude, 0],
        ])
      )[0]
      await player.Native.NodeProxy.setNodeGisPos(node, [
        sceneOptions.longitude,
        sceneOptions.latitude,
        elevation,
      ])
      obj.code.isEnableGis = true
    } else {
      await player.Native.NodeProxy.setLocalTranslation(node, obj.localPosition)
    }
    await player.Native.NodeProxy.setLocalRotation(node, obj.localRotation)
    await player.Native.NodeProxy.setLocalScaling(node, obj.localScaling)
    // 设置节点属性
    await player.Native.NodeProxy.setNodeInfo(node, {
      name: obj.name,
      code: JSON.stringify(obj.code),
      id: obj.guid,
    })
    // 递归子，继续创建
    if (obj.children && obj.children.length) {
      for (let i = 0; i < obj.children.length; ++i) {
        await loadSceneFromJson(obj.children[i], node, player, sceneOptions, nodes, loadCallback)
      }
    }
  }
  return nodes
}
// 保存场景到json对象
const saveSceneToJson = async (node, player) => {
  if (!node) return null
  const nodeInfo = await player.Native.Node.getProperty(node, ['name', 'code', 'localTrans', 'localRot', 'localScale', 'children'])
  const obj = {}
  obj.name = nodeInfo.name
  obj.code = nodeInfo.code ? JSON.parse(nodeInfo.code) : ''
  obj.guid = nodeInfo.id
  obj.localPosition = nodeInfo.localTrans
  obj.localRotation = nodeInfo.localRot
  obj.localScaling = nodeInfo.localScale
  // 根据节点类型，序列化某些特有类型的节点数据
  if (obj.code.type) {
    if (obj.code.type === 'Root') {
      const cameraParams = await player.Native.Camera.currentParam()
      obj.cameraParams = JSON.stringify(cameraParams)
    }
    const modelChild = _.filter(nodeInfo.children, (item) => {
      return item.code && isJSONObj(item.code) && JSON.parse(item.code).type
    })
    if (!_.isEmpty(modelChild)) {
      obj.children = []
      for (let i = 0; i < modelChild.length; i += 1) {
        const childObj = await saveSceneToJson(modelChild[i].node, player)
        if (childObj) {
          obj.children.push(childObj)
        }
      }
    }
    return obj
  }
  // 层级节点，需要继续递归
  obj.children = []
  const filterChilds = _.filter(nodeInfo.children, (el) => {
    return el.code
  })
  for (let i = 0; i < filterChilds.length; ++i) {
    const childObj = await saveSceneToJson(filterChilds[i].nodePtr, player)
    if (childObj != null) obj.children.push(childObj)
  }
  return obj
}
// 通过指定节点去查下面的子节点 nodeType 指定节点的类型，obj 需要筛选的对象数据源，arr 接收筛选后的数据集合
const getNodesByNodeType = async (obj, arr = []) => {
  // let currentNodeType = obj.code && obj.code.type
  const currentNodeType = obj?.code?.type
  if (EnumObjectTypes.includes(currentNodeType)) {
    const nowObj = _.cloneDeep(obj)
    delete nowObj.children
    arr.push(nowObj)
  }
  // 递归子，继续创建
  if (obj.children && obj.children.length) {
    for (let i = 0; i < obj.children.length; ++i) {
      await getNodesByNodeType(obj.children[i], arr)
    }
  }
  return arr
}
const getPoint = (p0, p1, t) => {
  return [p0[0] + (p1[0] - p0[0]) * t, p0[1] + (p1[1] - p0[1]) * t, p0[2] + (p1[2] - p0[2]) * t]
}
const loadAction = async (data, node, config, player) => {
  // 创建路径动画混合器
  const mixer = await player.Native.AnimationMixer.getMixer('mixer')
  const clip = await player.Native.AnimationClip.getClip(mixer, 'clip')
  const action = await player.Native.AnimationAction.clipAction(mixer, clip)
  await player.Native.AnimationAction.setLoop(action, config.loopType, -1)
  const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  if (clipTrackCount > 0) {
    await player.Native.KeyframeTrack.clearTrack(clip)
  }
  // 创建位置关键帧轨道
  const trackT = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalTranslation',
    trackType: EnumKFTTReal3,
    propertyLinkType: EnumAPBTTranslation,
    interpolationType: 0
  })

  // 根据路径顶点添加位置关键帧
  await player.Native.KeyframeTrack.keyClear(trackT)
  // 创建旋转关键帧轨道
  const trackR = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalRotation',
    trackType: EnumKFTTQuaternion,
    propertyLinkType: EnumAPBTRotation,
    interpolationType: 0
  })
  await player.Native.KeyframeTrack.keyClear(trackR)
  // 创建缩放关键帧轨道
  const trackS = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalScaling',
    trackType: EnumKFTTReal3,
    propertyLinkType: EnumAPBTScaling,
    interpolationType: 0
  })
  let time = 0
  await player.Native.KeyframeTrack.keyClear(trackS)
  const TKeys = []
  const RKeys = []
  const SKeys = []
  for (let i = 0; i < data.length; i += 1) {
    const item = data[i]
    const animationData = JSON.parse(item.properties)
    // 计算当前关键帧时间
    if (i > 0) {
      const lastAnimationData = JSON.parse(data[i - 1].properties)
      const v = config.speed * 1
      // 加速阶段的初速度
      const v0 = v * 0.2
      // 两个关键点之间的总距离(路程)
      const s = Vec3.length(Vec3.sub(lastAnimationData.localPosition, animationData.localPosition))
      // 加速阶段的距离
      const s1 = s * 0.2
      if (config.speedCurve === 2) {
        const hastenEndPoint = getPoint(
          lastAnimationData.localPosition,
          animationData.localPosition,
          0.2
        )
        const decelerateBeginPoint = getPoint(
          lastAnimationData.localPosition,
          animationData.localPosition,
          0.8
        )
        // 计算加速阶段时长
        time += s1 / v0
        // // 加速过程
        TKeys.push({ keyframeTrack: trackT, time, value: hastenEndPoint })
        // 匀速过程
        time += (s - 2 * s1) / v
        // 添加位置关键帧
        TKeys.push({ keyframeTrack: trackT, time, value: decelerateBeginPoint })
        // 减速过程
        time += s1 / v0 || v0
      } else if (config.speedCurve === 1) {
        const hastenEndPoint = getPoint(
          JSON.parse(data[0].properties).localPosition,
          JSON.parse(data[1].properties).localPosition,
          0.2
        )
        const decelerateBeginPoint = getPoint(
          JSON.parse(data[data.length - 2].properties).localPosition,
          JSON.parse(data[data.length - 1].properties).localPosition,
          0.8
        )
        if (i === 1) {
          // 加速过程
          // 计算加速阶段时长
          time += s1 / v0
          TKeys.push({ keyframeTrack: trackT, time, value: hastenEndPoint })
          // 匀速过程
          time += (s - s1) / v || v
        } else if (i === data.length - 1) {
          // 减速过程
          time += (s - s1) / v
          TKeys.push({ keyframeTrack: trackT, time, value: decelerateBeginPoint })
          time += s1 / v0 || v0
        } else {
          // 匀速过程
          time += s / v || v
        }
      } else {
        time += s / v || v
      }
    }
    // 添加位置关键帧
    TKeys.push({ keyframeTrack: trackT, time, value: animationData.localPosition })
    // 添加旋转关键帧
    RKeys.push({ keyframeTrack: trackR, time, value: animationData.localRotation })
    // 添加缩放关键帧
    SKeys.push({ keyframeTrack: trackS, time, value: animationData.localScaling })
  }
  const lastStatus = JSON.parse(data[data.length - 1].properties)
  const rotationQuat = EulerAngle.fromQuat(lastStatus.localRotation)
  const rotMat = EulerAngle.toRotationMatrix(rotationQuat)
  lastStatus.localRotation = Matrix4.decompose(rotMat).quaternion
  if (config.loopType === 2) {
    const TKeysReverse = [...TKeys].reverse()
    const RKeysReverse = [...RKeys].reverse()
    const SKeysReverse = [...SKeys].reverse()
    let TReverseTime = TKeysReverse[0].time
    let RReverseTime = RKeysReverse[0].time
    let SReverseTime = SKeysReverse[0].time
    lastStatus.localPosition = TKeysReverse[TKeysReverse.length - 1].value
    lastStatus.localRotation = RKeysReverse[RKeysReverse.length - 1].value
    lastStatus.localScaling = SKeysReverse[SKeysReverse.length - 1].value
    for (let i = 0; i < TKeysReverse.length; i += 1) {
      if (i > 0) {
        TReverseTime += TKeysReverse[i - 1].time - TKeysReverse[i].time
        TKeys.push({ keyframeTrack: trackT, time: TReverseTime, value: TKeysReverse[i].value })
      }
    }
    for (let i = 0; i < RKeysReverse.length; i += 1) {
      if (i > 0) {
        RReverseTime += RKeysReverse[i - 1].time - RKeysReverse[i].time
        RKeys.push({ keyframeTrack: trackR, time: RReverseTime, value: RKeysReverse[i].value })
      }
    }
    for (let i = 0; i < SKeysReverse.length; i += 1) {
      if (i > 0) {
        SReverseTime += SKeysReverse[i - 1].time - SKeysReverse[i].time
        SKeys.push({ keyframeTrack: trackS, time: SReverseTime, value: SKeysReverse[i].value })
      }
    }
    time = _.max([TReverseTime, RReverseTime, SReverseTime])
  }
  if (config.loopInterval && !_.isEmpty(data) && config.loopType !== 0) {
    TKeys.push({ keyframeTrack: trackT, time: time + config.loopInterval * 1, value: lastStatus.localPosition })
    RKeys.push({ keyframeTrack: trackR, time: time + config.loopInterval * 1, value: lastStatus.localRotation })
    SKeys.push({ keyframeTrack: trackS, time: time + config.loopInterval * 1, value: lastStatus.localScaling })
  }
  await player.Native.KeyframeTrack.batchKeyAppend([...TKeys, ...RKeys, ...SKeys])
  await player.Native.AnimationAction.bindActionUpdate(action)
  await player.Native.AnimationAction.play(action)

  return action
}
export {
  saveSceneToJson,
  loadSceneFromJson,
  isJSONObj,
  loadPrModel,
  loadParticle,
  getNodesByNodeType,
  generateGUID,
  loadAction,
  EnumObjectTypes,
}
